/* The Cozy Paw — small, dependency-free interactions */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHeader() {
    var header = document.querySelector('[data-cz-header]');
    if (!header || header.hasAttribute('data-cz-ready')) return;
    header.setAttribute('data-cz-ready', '');
    var host = header.closest('.shopify-section');
    if (host) host.classList.add('cz-header-host');
    var setH = function () {
      var h = header.offsetHeight;
      document.body.style.setProperty('--header-height', h + 'px');
      document.body.style.setProperty('--header-group-height', h + 'px');
    };
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(header);
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:8px;pointer-events:none';
    document.body.prepend(sentinel);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        header.classList.toggle('is-scrolled', !e[0].isIntersecting);
      }).observe(sentinel);
    }

    var drawer = document.getElementById('cz-menu');
    var openBtn = header.querySelector('[data-cz-menu-open]');
    if (drawer && openBtn && drawer.showModal) {
      openBtn.addEventListener('click', function () {
        drawer.showModal();
        openBtn.setAttribute('aria-expanded', 'true');
      });
      drawer.addEventListener('close', function () {
        openBtn.setAttribute('aria-expanded', 'false');
      });
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer || e.target.closest('[data-cz-menu-close]')) drawer.close();
      });
      window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) {
        if (m.matches && drawer.open) drawer.close();
      });
    }

    var toggle = header.querySelector('[data-cz-search-toggle]');
    var panel = header.querySelector('.cz-mobile-search');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var show = panel.hidden;
        panel.hidden = !show;
        toggle.setAttribute('aria-expanded', String(show));
        if (show) {
          var input = panel.querySelector('input[type=search]');
          if (input) input.focus();
        }
      });
    }
  }

  function initSearch(form) {
    if (form.hasAttribute('data-cz-ready')) return;
    form.setAttribute('data-cz-ready', '');
    var input = form.querySelector('input[type=search]');
    var box = form.querySelector('.cz-suggest');
    var url = form.getAttribute('data-suggest-url');
    if (!input || !box || !url) return;
    var timer, ctrl, money = form.getAttribute('data-money') || '';
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML.replace(/"/g, '&quot;'); }
    function fmt(p) {
      if (!p) return '';
      var n = parseFloat(p);
      if (isNaN(n)) return p;
      return money.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k.indexOf('no_decimals') > -1) return Math.round(n).toLocaleString();
        return n.toFixed(2);
      });
    }
    function render(products, q) {
      var html = '';
      if (!products.length) {
        html = '<p class="cz-suggest__empty">No products found for “' + esc(q) + '”.</p>';
      } else {
        html = '<ul role="list">' + products.map(function (p) {
          var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="48" height="48" loading="lazy">' : '';
          return '<li><a href="' + esc(p.url) + '">' + img + '<span><span class="cz-suggest__t">' + esc(p.title) + '</span><br><span class="cz-suggest__p">' + esc(fmt(p.price)) + '</span></span></a></li>';
        }).join('') + '</ul>';
      }
      html += '<a class="cz-suggest__all" href="' + esc(form.getAttribute('action')) + '?type=product&q=' + encodeURIComponent(q) + '">See all results</a>';
      box.innerHTML = html;
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = 'AbortController' in window ? new AbortController() : null;
        fetch(url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var list = (d && d.resources && d.resources.results && d.resources.results.products) || [];
            render(list, q);
          })
          .catch(function () {});
      }, 180);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); }
      if (e.key === 'ArrowDown' && !box.hidden) {
        var first = box.querySelector('a');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    box.addEventListener('keydown', function (e) {
      var links = Array.prototype.slice.call(box.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (i > 0 ? links[i - 1] : input).focus(); }
      if (e.key === 'Escape') { close(); input.focus(); }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    form.addEventListener('focusout', function (e) { if (e.relatedTarget && !form.contains(e.relatedTarget)) close(); });
  }

  var spotsBound = false;
  function closeSpots(except) {
    document.querySelectorAll('.cz-hotspot.is-open').forEach(function (s) {
      if (s === except) return;
      s.classList.remove('is-open');
      var b = s.querySelector('.cz-hotspot__dot');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function initHotspots() {
    if (spotsBound) return;
    spotsBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cz-hotspot__dot');
      if (btn) {
        var spot = btn.closest('.cz-hotspot');
        var open = !spot.classList.contains('is-open');
        closeSpots(spot);
        spot.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
        return;
      }
      if (!e.target.closest('.cz-hotspot')) closeSpots();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var spot = document.activeElement && document.activeElement.closest && document.activeElement.closest('.cz-hotspot');
      closeSpots();
      if (spot) spot.querySelector('.cz-hotspot__dot').focus();
    });
  }

  function initFilters(root) {
    if (root.hasAttribute('data-cz-ready')) return;
    root.setAttribute('data-cz-ready', '');
    var buttons = root.querySelectorAll('[data-cz-filter]');
    var cards = root.querySelectorAll('.cz-card');
    var list = root.querySelector('.cz-cards');
    var empty = root.querySelector('.cz-empty');
    var live = root.querySelector('[data-cz-live]');
    if (list) list.setAttribute('data-count', String(root.querySelectorAll('.cz-card:not([hidden])').length));
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-cz-filter');
        buttons.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        var shown = 0;
        cards.forEach(function (c) {
          var pets = (c.getAttribute('data-pets') || '').split(' ');
          var match = f === 'all' ? c.getAttribute('data-all') !== '0' :
            (f === 'both' ? pets.indexOf('dogs') > -1 && pets.indexOf('cats') > -1 : pets.indexOf(f) > -1);
          if (match) {
            shown++;
            if (c.hidden) {
              c.hidden = false;
              if (!reduce.matches) {
                c.classList.add('is-entering');
                requestAnimationFrame(function () { requestAnimationFrame(function () { c.classList.remove('is-entering'); }); });
              }
            }
          } else {
            c.hidden = true;
          }
        });
        if (list) {
          list.setAttribute('data-count', String(shown));
          list.classList.toggle('is-single', shown === 1);
          list.scrollLeft = 0;
        }
        if (empty) empty.hidden = shown !== 0;
        if (live) live.textContent = shown + (shown === 1 ? ' product' : ' products') + ' shown';
      });
    });
  }

  function initSwing() {
    var items = document.querySelectorAll('[data-cz-swing]:not([data-cz-watch])');
    if (!items.length || reduce.matches || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        el.classList.add('is-swinging');
        var inner = el.querySelector('.cz-polaroid__swing');
        if (inner) inner.addEventListener('animationend', function () { el.classList.remove('is-swinging'); }, { once: true });
      });
    }, { threshold: 0.45 });
    items.forEach(function (el) { el.setAttribute('data-cz-watch', ''); io.observe(el); });
  }

  function init() {
    initHeader();
    document.querySelectorAll('form.cz-search').forEach(initSearch);
    initHotspots();
    document.querySelectorAll('[data-cz-discover]').forEach(initFilters);
    initSwing();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
